import select from 'dom-select';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import { unset, getBreakpoint } from 'utils/general';
import { i18n } from 'lib/i18n.js';
import bus from 'lib/bus';

const headerEl = select('.js-header');

export default {
  props: [
    'ssSiteId',
    'ssShopperId',
    'ssCollectionId',
    'ssCollectionTitle',
    'ssCollectionHandle',
    'collectionHandle',
    'ssTags',
    'ssTemplate',
    'ssVariantSize',
    'isExploded'
  ],

  data() {
    return {
      searchTerm: '',
      loading: false,
      viewportSize: '',
      isOpen: false,
    };
  },

  mounted() {
    this.injectSSScript();

    bus.$on('focus-search-overlay', () => {
      this.isOpen = true;
      this.$nextTick(() => {
        const searchInput = this.$refs['search-input'];
        if (searchInput) {
          searchInput.focus({ preventScroll: true });
          searchInput.select();
        }
      });
    });

    this.viewportSize = getBreakpoint();
    this.handleKeyboardClose();
  },

  created() {
    window.addEventListener('resize', this.resizeHandler);
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },

  watch: {
    searchTerm(value) {
      this.loading = true;
    },
  },

  computed: {
    hasResults() {
      if (!this.searchTerm.length) {
        return false;
      }
    },
  },

  methods: {
    resizeHandler() {
      this.viewportSize = getBreakpoint();
    },
    close() {
      unset(headerEl, 'showing-search-overlay');
      clearAllBodyScrollLocks();
      this.isOpen = true;
    },
    handleKeyboardClose(e) {
      document.addEventListener('keyup', (e) => {
        if (e.keyCode === 27 && this.isOpen) {
          this.close();
          document
            .querySelector('.header__icons-item--desk .icon-btn--heart')
            ?.focus();
        }
      });
    },
    clear() {
      this.searchTerm = '';
    },
    injectSSScript() {
      if (this.ssSiteId) {
        const ssScript = document.createElement('script');
        ssScript.setAttribute(
          'src',
          `https://snapui.searchspring.io/${this.ssSiteId}/bundle.js`,
        );
        ssScript.id = 'searchspring-context';
        if (this.ssShopperId) {
          const shopperConfig = document.createTextNode(
            `shopper = { id: "${this.ssShopperId}" };`,
          );
          ssScript.appendChild(shopperConfig);
        }

        if (
          this.collectionHandle &&
          this.ssTemplate.includes('collection') &&
          this.collectionHandle !== this.ssCollectionHandle
        ) {
          const collectionConfig = document.createTextNode(
            `collection = { id: "${this.ssCollectionId}", name: "${this.ssCollectionTitle}", handle: "${this.collectionHandle}", variant_size: "${this.ssVariantSize}" };`,
          );
          const isExploded = document.createTextNode(
            `isExploded="${this.isExploded}";`,
          )
          ssScript.appendChild(collectionConfig);
          ssScript.appendChild(isExploded);
        }

        if (this.ssTags) {
          const tagsConfig = document.createTextNode(
            `tags = "${this.ssTags}";`,
          );
          ssScript.appendChild(tagsConfig);
        }

        if (this.ssTemplate) {
          const templateConfig = document.createTextNode(
            `template = "${this.ssTemplate}";`,
          );
          ssScript.appendChild(templateConfig);
        }

        if (window.__GLOBAL__.moneyFormat) {
          const moneyFormatConfig = document.createTextNode(
            `format = "${window.__GLOBAL__.moneyFormat}";`,
          );
          ssScript.appendChild(moneyFormatConfig);
        }

        document.head.appendChild(ssScript);
      }
    },
  },
  i18n,
};
